import env from "env";

export class DocumentsUtils {
    // DocumentsUtils.downloadDoc('XXXXXXXXXXXXX')
    public static downloadDoc(idDocumento: string) {
        const apiUrl = env.API_URL;
        const url = (apiUrl + 'documentos/' + idDocumento + '/content');
        window.open(url, '_blank');
    }
}